import { atom } from "recoil";
import { EDITOR_MODES } from "../constants/editorMode.constants";

export const saveModeAtom = atom({
    key: 'save-mode',
    default: "online"
});

export const viewRecentModeAtom = atom({
    key: "view-recent-mode",
    default: "online"
});

export const editorModeAtom = atom({
    key: "editor-mode",
    default: EDITOR_MODES.NOTE
});
